import { render } from "./TSAVideo.vue?vue&type=template&id=fd60fdc6&scoped=true"
import script from "./TSAVideo.vue?vue&type=script&lang=js"
export * from "./TSAVideo.vue?vue&type=script&lang=js"

import "./TSAVideo.vue?vue&type=style&index=0&id=fd60fdc6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd60fdc6"]])

export default __exports__